/* global attachEvent, VideoPlayer */
// *******************************************************************************
// 1.0 - Embed Video
// *******************************************************************************

attachEvent('.video__poster', 'click', (ev) => {
  if (ev.target.closest('[data-video-wrapper')) {
    const parentElem = ev.target.closest('[data-video-wrapper]');
    VideoPlayer(parentElem);
  } else {
    const parentElem = ev.target.closest('[data-video-wrapper-stream]');
    const streamIframe = parentElem.querySelector('.video__iframe-container');
    const video = parentElem.querySelector('.video');
    streamIframe.src += '?&autoplay=1';
    video.classList.add('is-playing');
  }
});
